module.exports = __webpack_public_path__ + "img/es.2d451b3c.svg";